import { createEnum } from "@redotech/zod-util/zod-enum";

export enum RedoListingStatus {
  ACTIVE = "active",
  DRAFT = "draft",
  ARCHIVED = "archived",
  INACTIVE = "inactive",
  DELETED = "deleted",
}
export const RedoListingStatusSchema = createEnum(RedoListingStatus);
